import React, { useState, useEffect } from 'react';
import { tippspielAdminAPI } from '../../services/api';

const TippspielMatchControl = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    tippspielAdminAPI.listMatches()
      .then((res) => setMatches(res.data || []))
      .catch((err) => setError(err.response?.data?.message || 'Laden fehlgeschlagen'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const recalcMatch = async (id) => {
    await tippspielAdminAPI.recalculateMatch(id);
    load();
  };

  if (loading) {
    return <div className="flex justify-center py-12"><span className="loading loading-spinner loading-lg text-wacker" /></div>;
  }
  if (error) return <div className="alert-error-dark">{error}</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center flex-wrap gap-3">
        <h2 className="section-title"><span>Spiele</span></h2>
        <button type="button" className="btn-wacker-outline text-sm py-2 px-4" onClick={load}>Aktualisieren</button>
      </div>

      <div className="overflow-x-auto glass-card">
        <table className="table w-full">
          <thead>
            <tr>
              <th>Spiel</th>
              <th>Anpfiff</th>
              <th>Ergebnis</th>
              <th>Status</th>
              <th>Deadline</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {matches.map((m) => (
              <tr key={m._id}>
                <td>{m.homeTeamName} vs {m.awayTeamName}</td>
                <td className="text-sm text-white/70">{m.kickoffAt ? new Date(m.kickoffAt).toLocaleString('de-DE') : '–'}</td>
                <td>
                  {m.resultRegular?.home != null
                    ? `${m.resultRegular.home}:${m.resultRegular.away}`
                    : '–'}
                </td>
                <td><span className="text-xs px-2 py-1 rounded-lg bg-white/10">{m.status}</span></td>
                <td className="text-sm text-white/70">{m.tipDeadlineAt ? new Date(m.tipDeadlineAt).toLocaleString('de-DE') : '–'}</td>
                <td>
                  <button type="button" className="text-wacker-light hover:underline text-sm" onClick={() => recalcMatch(m._id)}>
                    Neu werten
                  </button>
                </td>
              </tr>
            ))}
            {matches.length === 0 && (
              <tr><td colSpan={6} className="text-center text-white/50 py-8">Keine Spiele. Bitte zuerst synchronisieren.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TippspielMatchControl;
